module.exports = __webpack_public_path__ + "static/media/success.e4262260.png";